import React, { useCallback, useMemo } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal, Tappable } from '@vectord/components';

import {
  academyTopicsSelector,
  confirmationModalSelector,
  scheduleErrorsSelector,
  setAcademyTopicsDate,
  setConfirmationOpen,
  setScheduleClassesFormErrors,
} from 'features/classCreation';
import ConfirmScheduleButton from '../ConfirmScheduleButton';
import FieldErrors from 'components/FieldErrors';
import ScheduleConfirmationClassRow from '../ScheduleConfirmationClassRow';
import styles from './ScheduleConfrimationModal.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function ScheduleConfrimationModal({ classes }) {
  const isOpen = useSelector(confirmationModalSelector);
  const dispatch = useDispatch();

  const academyTopics = useSelector(academyTopicsSelector);
  const errors = useSelector(scheduleErrorsSelector);

  const selectedClasses = useMemo(() => {
    return classes.filter(
      (cls) => academyTopics[cls.academy_topic.id]?.selected
    );
  }, [academyTopics, classes]);

  const handleClose = useCallback(() => {
    batch(() => {
      dispatch(setConfirmationOpen(false));
      // Empty object will reset all dates
      dispatch(setAcademyTopicsDate({ dates: {} }));
      dispatch(setScheduleClassesFormErrors({}));
    });
  }, [dispatch]);

  return (
    <Modal
      className={styles.root}
      isOpen={isOpen}
      onClose={handleClose}
      size="extraLarge"
      canClose={false}
      unMountOnClose
      withoutHeader
    >
      <Table className={styles.table}>
        <TableHead className={styles.header}>
          <TableRow>
            <TableCell className={styles.classTitle}>Classes</TableCell>
            <TableCell className={styles.junctionNumber}>Junction</TableCell>
            <TableCell className={styles.primaryInstructor}>
              Primary Instructor
            </TableCell>
            <TableCell className={styles.secondaryInstructor}>
              Secondary Instructor
            </TableCell>
            <TableCell className={styles.otherInstructors}>
              Other Instructor(s)
            </TableCell>
            <TableCell className={styles.date}>Proposed Date & Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedClasses.map((cls) => (
            <ScheduleConfirmationClassRow
              key={cls.id}
              cls={cls}
            />
          ))}
        </TableBody>
      </Table>
      <FieldErrors
        name="classes_schedule"
        prefixName={false}
        errors={errors}
      />
      <div className="row align-c justify-end m-t-xs m-b-xxs">
        <Tappable
          onClick={handleClose}
          className="btn btn-primary btn-inverted btn-small btn-long m-r-xxs"
        >
          Go Back
        </Tappable>
        <ConfirmScheduleButton classes={classes} />
      </div>
    </Modal>
  );
}

export default ScheduleConfrimationModal;
